import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Whiteboard = forwardRef<SVGSVGElement, SvgIconProps>(
  function Whiteboard(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M9.19 12.229H2.593c-.614 0-1.092-.482-1.092-1.053 0-.593.5-1.054 1.092-1.054H9.19c1.798 0 2.798-.878 4.05-1.975 1.228-1.076 2.685-2.349 5.119-2.898l-1.48-.812a1.011 1.011 0 01-.408-1.405c.296-.505.955-.68 1.479-.395l4.003 2.195c.273.175.479.439.524.746.023.066.023.11.023.176a1 1 0 01-.273.68l-3.299 3.645c-.386.44-1.069.46-1.524.088a1.036 1.036 0 01-.364-.79 1 1 0 01.273-.682l1.16-1.273c-1.639.439-2.685 1.36-3.777 2.305-1.433 1.228-2.889 2.502-5.505 2.502zm7.479 8.059a1.202 1.202 0 01-1.585-.197.956.956 0 01-.237-.629c0-.326.166-.63.45-.825l1.277-.891c-3.005-.412-4.709-1.824-6.083-2.976-.52-.435-.994-.804-1.491-1.13h1.326c.686 0 1.325-.086 1.893-.216 1.23 1.02 2.51 1.976 4.686 2.28l-1.49-1.195a.99.99 0 01-.095-1.455c.402-.412 1.112-.455 1.585-.086l3.716 2.997c.26.195.379.5.379.804a1.09 1.09 0 01-.45.782l-3.881 2.737z" />
      </SvgIcon>
    )
  },
)

export default Whiteboard
